import { ComboField } from '@components/Fields/ComboField';
import { StringField } from '@components/Fields/StringField';
import { FixedFilterPanel } from '@components/FixedFilterPanel';
import { GridItem } from '@components/GridItem';
import { HorizontalGrid } from '@components/HorizontalGrid';
import { IFilter } from '@hooks/useFilter';
import { Divider, MenuItem } from '@material-ui/core';
import { EnumUsuarioStatus, IComboUsuarioStatus } from '@model/UsuarioStatus';
import { IUsuarioFilter } from '@services/UsuarioService';
import React from 'react';

export type UsuarioFilterProps = {
    filter: IFilter<IUsuarioFilter>
    isLoading: boolean
    usuarioStatusCombo: IComboUsuarioStatus
}

export function UsuarioFilter ({ filter, isLoading, usuarioStatusCombo }: UsuarioFilterProps) {
    const handleReset = React.useCallback(() => {
        filter.resetFilter();
    }, [filter]);

    return (
        <FixedFilterPanel
            onSearch={filter.handleFilterRequest}
            onClear={handleReset}
            disabled={isLoading}
        >
            <HorizontalGrid spacing={1}>
                <GridItem xs={3}>
                    <StringField
                        field={filter.fields.nome}
                        label="Nome"
                        onEnter={filter.handleFilterRequest}
                        fullWidth
                        disabled={isLoading}
                        InputLabelProps={{
                            shrink: true
                        }}
                    />
                </GridItem>

                <GridItem xs={2}>
                    <ComboField
                        field={filter.fields.usuarioStatusId}
                        label="Status Usuário"
                        onEnter={filter.handleFilterRequest}
                        fullWidth
                        disabled={isLoading}
                        InputLabelProps={{
                            shrink: true
                        }}
                    >
                        <MenuItem key={0} value={EnumUsuarioStatus.None}>Todos</MenuItem>
                        <Divider />

                        {
                            usuarioStatusCombo.createOptions()
                        }
                    </ComboField>
                </GridItem>
            </HorizontalGrid>
        </FixedFilterPanel>
    )
}